import React from 'react';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import FilterSection from './FilterSection';
import DateRangeFilterSectionStyles from './DateRangeFilterSection.module.css';

import { updateGradebook } from '../../../../actions/gradebook';
import { isGradebookV2ActiveSelector } from '../../../../selectors/search-gradebook';
import { connect } from 'react-redux';
import { DATE_RANGE_GB_FILTER_SECTION_ID } from '../../../../utils/constants';

import MLDateTimePickerStyle from '../../../../components/MLDateTimePicker/MLDateTimePicker.module.css';
import MLButton from '../../../MLButton/MLButton';

const DATE_RANGE_FILTER_SECTION_HEADER = 'Date Range';

function handleDayClick({ dispatch, day, searchDateFrom, searchDateTo }) {
  const { from, to } = DateUtils.addDayToRange(day, {
    from: searchDateFrom,
    to: searchDateTo,
  });
  dispatch(updateGradebook({ searchDateTo: to, searchDateFrom: from }));
}

function subtractDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
}

function lastNDays({ dispatch, n }) {
  const searchDateTo = new Date();
  const searchDateFrom = subtractDays(searchDateTo, n);
  dispatch(updateGradebook({ searchDateFrom, searchDateTo }));
}

const selectedStyles = {
  background: 'var(--prs-c-primary)',
  color: '#f8f8f8',
};

const DateRangeFilterSection = ({
  dispatch,
  visibleFilter,
  searchDateFrom,
  searchDateTo,
}) => (
  <FilterSection
    dispatch={dispatch}
    visibleFilter={visibleFilter}
    id={DATE_RANGE_GB_FILTER_SECTION_ID}
    headerText={DATE_RANGE_FILTER_SECTION_HEADER}
  >
    <div className={DateRangeFilterSectionStyles.body}>
      <DayPicker
        selectedDays={{ from: searchDateFrom, to: searchDateTo }}
        modifiers={{ edges: [searchDateFrom, searchDateTo] }}
        modifiersStyles={{
          edges: selectedStyles,
        }}
        classNames={{
          container: MLDateTimePickerStyle.DayPicker,
          wrapper: DateRangeFilterSectionStyles.DayPicker_wrapper,
          interactionDisabled:
            MLDateTimePickerStyle.DayPickerinteractionDisabled,
          navBar: MLDateTimePickerStyle.DayPickerNavBar,
          navButtonPrev: `${MLDateTimePickerStyle.DayPickerNavButton} ${MLDateTimePickerStyle.DayPickerNavButtonPrev}`,
          navButtonNext: `${MLDateTimePickerStyle.DayPickerNavButton} ${MLDateTimePickerStyle.DayPickerNavButtonNext}`,
          navButtonInteractionDisabled:
            MLDateTimePickerStyle.DayPickerNavButtonInteractionDisabled,

          month: MLDateTimePickerStyle.DayPickerMonth,
          caption: MLDateTimePickerStyle.DayPickerCaption,
          weekdays: MLDateTimePickerStyle.DayPickerWeekdays,
          weekdaysRow: MLDateTimePickerStyle.DayPickerWeekdaysRow,
          weekday: MLDateTimePickerStyle.DayPickerWeekday,
          body: MLDateTimePickerStyle.DayPickerBody,
          week: MLDateTimePickerStyle.DayPickerWeek,
          day: DateRangeFilterSectionStyles.filterDay,

          footer: MLDateTimePickerStyle.DayPickerFooter,
          todayButton: MLDateTimePickerStyle.DayPickerTodayButton,

          today: MLDateTimePickerStyle.DayPickerDayToday,
          selected: DateRangeFilterSectionStyles.DayPicker_selected,
          disabled: '',
          outside: MLDateTimePickerStyle.DayPickerDayOutside,
        }}
        onDayClick={(day) => {
          handleDayClick({
            dispatch,
            day,
            searchDateFrom,
            searchDateTo,
          });
        }}
      />
      <MLButton
        className={DateRangeFilterSectionStyles.button}
        btnType="secondary"
        testId="last-seven-days"
        onClick={() => {
          lastNDays({ dispatch, n: 7 });
        }}
      >
        <span>Last Seven Days</span>
      </MLButton>
      <MLButton
        className={DateRangeFilterSectionStyles.button}
        btnType="secondary"
        testId="last-30-days"
        onClick={() => {
          lastNDays({ dispatch, n: 30 });
        }}
      >
        <span>Last 30 Days</span>
      </MLButton>
    </div>
  </FilterSection>
);

DateRangeFilterSection.propTypes = {
  visibleFilter: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchDateFrom: PropTypes.object,
  searchDateTo: PropTypes.object,
  isGradebookV2Active: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isGradebookV2Active: isGradebookV2ActiveSelector(state),
  };
}

export default connect(mapStateToProps)(DateRangeFilterSection);
